import * as React from 'react';
import { connect } from 'react-redux';

import { submitLocationApplicationForm } from '../../../../actions/hiring';
import ApplicationForm from '../ApplicationForm';

interface OwnProps {
  locationProfileUrl: string;
  locationCountryCode: string;
}

interface StateProps {
  isSubmitting: boolean;
}

interface DispatchProps {
  onSubmit: (payload: Record<string, unknown>) => void;
}

type LocationApplicationFormProps = OwnProps & StateProps & DispatchProps;

const LocationApplicationForm: React.FC<LocationApplicationFormProps> = ({
  locationProfileUrl,
  locationCountryCode,
  isSubmitting,
  onSubmit,
}) => (
  <ApplicationForm
    onSubmit={onSubmit}
    isSubmitting={isSubmitting}
    locationProfileUrl={locationProfileUrl}
    locationCountryCode={locationCountryCode}
  />
);

interface ImmutableState {
  getIn<T>(path: Array<string>): T | undefined;
}

const mapStateToProps = (state: ImmutableState): StateProps => ({
  isSubmitting:
    state.getIn<boolean>([
      'hiring',
      'locationApplicationForm',
      'isSubmitting',
    ]) || false,
});

export default connect(mapStateToProps, {
  onSubmit: submitLocationApplicationForm,
})(LocationApplicationForm);
